/**
 * Rôles applicatifs. « super_admin » voit, en plus, les outils mis de côté à
 * la demande du cabinet (retours du 4 mai et du 14 octobre 2026 : Patrimoine
 * reste un outil de suivi d'activité, la conformité et le CRM complet sont
 * confiés à un logiciel du marché). Le code de ces outils est conservé : ils
 * ne sont simplement ni affichés ni accessibles aux autres comptes.
 */
export const ROLES = ["user", "super_admin"] as const;
export type Role = (typeof ROLES)[number];

export const estSuperAdmin = (u: { role?: string | null } | null | undefined): boolean => u?.role === "super_admin";

/** Message affiché à la connexion d'un compte suspendu (formulaire et retour de Google). */
export const MESSAGE_COMPTE_SUSPENDU =
  "Ce compte est suspendu : vous ne pouvez pas vous connecter. Contactez l'administrateur du site si vous pensez qu'il s'agit d'une erreur.";
